import { Component, inject, Input, OnInit, signal } from '@angular/core';

import { ShopService } from '@app/shared/services/shop.service';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { ShopOffer } from '@app/shared/models/offer.model';
import { AnimatedTimerComponent } from '@app/shared/components/animated-timer/animated-timer.component';
import { BadgeComponent } from '@app/shared/components/badge/badge.component';
import { SharedModule } from '@app/shared/shared.module';
import { ThemingAssets } from '@app/shared/services/theming.service';
import { OffersRepository } from '@app/shared/state/offer/offer.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-shop-offer',
  templateUrl: './shop-offer.component.html',
  styleUrls: ['./shop-offer.component.scss'],
  standalone: true,
  imports: [AnimatedTimerComponent, SharedModule, BadgeComponent],
})
export class ShopOfferComponent implements OnInit {
  @Input() theming: ThemingAssets;

  offerTimeToExpire: Date;
  displayOffer = false;
  offers = signal<ShopOffer[]>([]);

  remainingSecondsValue = 0;

  public readonly shopService = inject(ShopService);
  private readonly offersRepo = inject(OffersRepository);
  private readonly eventManager = inject(EventManager);
  public readonly logger = inject(LoggerService);

  ngOnInit() {
    this.offersRepo.offers$.subscribe((shopOffer: ShopOffer[]) => {
      this.offers.set(shopOffer);

      this.remainingSecondsValue = this.computeRemainingSeconds();

      if (this.remainingSecondsValue <= 0) {
        document.getElementById('offer-container')?.classList.add('offer-container-hide');
        this.displayOffer = false;
      } else {
        const currentDate = new Date();
        currentDate.setSeconds(currentDate.getSeconds() + this.remainingSecondsValue);

        this.offerTimeToExpire = currentDate;
        this.displayOffer = true;
      }
    });
  }

  openMessageDeal(): void {
    if (this.remainingSecondsValue > 0) {
      this.eventManager.openModal(new Modal(NonPersistedModalName.OfferModalComponent, ModalType.View));
    }
  }

  onExpired() {
    if (document.getElementById('offer-container'))
      document.getElementById('offer-container').classList.add('offer-container-hide');
  }

  private computeRemainingSeconds(): number {
    if (this.offers()?.length) {
      const expDate = new Date(this.offers()[0].expirationDate);
      const currentDate = new Date();

      return Math.max((expDate.getTime() - currentDate.getTime()) / 1000, 0);
    }

    return 0;
  }
}
